<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="customerUsersHeadings" :data="customerUsers" :hasActions="false"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @filterSearchClicked="onFilterSearchClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div>
                                            <label>Role</label>
                                            <bootstrap-select  :selectOptions="customerUserRoles" :selectedOption="filter.selectedCustomerUserRoleId" :elementId="'roleFilterSelect'"
                                                               :returnSelectedOptionText="true"
                                                               @changeSelect="onRoleFilterSelect"></bootstrap-select>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="float-right">
                                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                           :componentId="'customerFilterRadioButtons'"
                                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

</div>
